import script from "./HeroSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeroSection.vue?vue&type=script&setup=true&lang=ts"

import "./HeroSection.vue?vue&type=style&index=0&id=1e0b408c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e0b408c"]])

export default __exports__